import { axios } from "../../../lib/axios"

export const listMedicationsForPatient = (payload, patientId) => {
    return axios.get(`medication/${patientId}?date=${payload.date}`);
}

export const addMedicationTakenForPatient = (payload) => {
    return axios.put(`medication/${payload.data.patientId}/${payload.data.medicationId}`, payload);
}